// Presets.js
import moment from 'moment';
import { getNextChristmas, getDrinkingTime, getNextNewYear } from './Moments';

const presets = {
    default: {
        endDate: moment().add(1, 'days').format('YYYY-MM-DDTHH:mm'),
        customText: "Click menu button to customize",
        finalText: 'Time is up!',
        fontSize: 35,
        selectedFont: "Arial",
        textColor: "#ffffff",
        backgroundColor: "#e64141",
        isBold: true,
        marqueeSpeed: "snail",
        selectedEffect: "bounce",
        swingPixels: "3",
        selectedTheme: "custom",
        useGradient: true,
        gradientStartColor: "#8d6595",
        gradientEndColor: "#3e0349",
        useLineBreak: true,
        showBubbles: false,
        bubblesType: 'normal',
        selectedEmoji: '🌟',
        floatSpeed: 5,
        useTextShadow: false
    },
    xmas: {
        endDate: getNextChristmas(),
        customText: "🎄 Merry X-Mas 🎄",
        finalText: 'Time is up!',
        fontSize: 35,
        selectedFont: "Pacifico",
        textColor: "#2e5b1a",
        backgroundColor: "#e64141",
        isBold: true,
        marqueeSpeed: "snail",
        selectedEffect: "bounce",
        swingPixels: "5",
        selectedTheme: "custom",
        useGradient: true,
        gradientStartColor: "#c29393",
        gradientEndColor: "#e64141",
        useLineBreak: true,
        showBubbles: true,
        bubblesType: 'normal',
        selectedEmoji: '🥂',
        useTextShadow: true
    },
    newyear: {
        endDate: getNextNewYear(),
        customText: "New year countdown",
        finalText: '🍾 HAPPY NEW YEAR 🍾',        
        fontSize: 35,
        selectedFont: "Barlow",
        textColor: "#443a08",
        backgroundColor: "#ffffff",
        isBold: true,
        marqueeSpeed: "snail",
        selectedEffect: "bounce",
        swingPixels: "1",
        selectedTheme: "custom",
        useGradient: true,
        gradientStartColor: "#ecdf88",
        gradientEndColor: "#5c560f",
        useLineBreak: true,
        showBubbles: true,
        bubblesType: 'emoji',
        selectedEmoji: '🥂',
        useTextShadow: false
    },
    beer: {
        endDate: getDrinkingTime(),
        customText: "🍺 When is it time to drink? 🍺",
        finalText: 'Now is the time to drink!',
        fontSize: 30,
        selectedFont: "Freckle Face",
        textColor: "#695a26",
        backgroundColor: "#ffec8b",
        isBold: true,
        marqueeSpeed: "medium",
        selectedEffect: "bounce",
        swingPixels: "4",
        selectedTheme: "custom",
        useGradient: true,
        gradientStartColor: "#f7e09a",
        gradientEndColor: "#d4a106",
        useLineBreak: true,
        showBubbles: true,
        bubblesType: 'normal',
        selectedEmoji: '🍺',
        useTextShadow: true
    },
    zen: {
        endDate: moment().add(30, 'seconds').format('YYYY-MM-DDTHH:mm:ss'),
        customText: "🧘‍♀️ zen 🧘‍♂️",
        finalText: "Back to work!",
        fontSize: 35,
        selectedFont: "Barlow",
        textColor: "#ffffff",
        backgroundColor: "#e64141",
        isBold: true,
        marqueeSpeed: "snail",
        selectedEffect: "bounce",
        swingPixels: "3",
        selectedTheme: "custom",
        useGradient: true,
        gradientStartColor: "#8d6595",
        gradientEndColor: "#3e0349",
        useLineBreak: true,
        showBubbles: false,
        bubblesType: 'emoji',
        selectedEmoji: '🧘‍♀️',
        useTextShadow: false
    }
};

export const applyPreset = (presetKey, setStateFunctions) => {
    const preset = presets[presetKey];
    if (!preset) return;

    Object.entries(preset).forEach(([key, value]) => {
        if (key in setStateFunctions) {
            setStateFunctions[key](value);
        }
    });
};

export default presets;
